<aside class="yllw-sidenav" [class.yllw-sidenav--collapsed]="!expanded()">
    <!-- Logo + Toggle row -->
    <div class="yllw-sidenav__action-row">
        <a class="yllw-sidenav__logo-link" [routerLink]="homeRoute()"
            [pTooltip]="'SIDEBAR.BACK_TO_START' | translate" tooltipPosition="right">
            <img src="assets/images/yllw-logo-full.svg" alt="YLLW" class="yllw-sidenav__logo"
                [class.yllw-sidenav__logo--hidden]="!expanded()" />
            <img src="assets/images/yllw-logo-icon.svg" alt="YLLW" class="yllw-sidenav__logo-icon"
                [class.yllw-sidenav__logo-icon--hidden]="expanded()" />
        </a>
        <div class="yllw-sidenav__action-buttons">
            <button class="yllw-sidenav__action-btn yllw-sidenav__action-toggle-btn" (click)="toggle()"
                [pTooltip]="expanded() ? ('SIDEBAR.COLLAPSE' | translate) : ('SIDEBAR.EXPAND' | translate)"
                tooltipPosition="right">
                <i class="pi pi-angle-double-left yllw-sidenav__toggle-icon"
                    [class.yllw-sidenav__toggle-icon--collapsed]="!expanded()"></i>
                <app-kbd-shortcut [keys]="SHORTCUTS.LEFT_SIDEBAR_TOGGLE" size="sm" (pressed)="toggle()" />
            </button>
        </div>
    </div>

    <nav class="yllw-sidenav__nav">
        @if (!hasNavigated()) {
            <!-- Skeleton: don't commit to a view until the router has resolved the first URL -->
            <div class="yllw-sidenav__skeleton">
                @for (_ of skeletonRows; track $index) {
                    <p-skeleton height="2rem" styleClass="yllw-sidenav__skeleton-row" />
                }
            </div>
        } @else {
            <div class="yllw-sidenav__view" [@navViewSwitch]="activeView()" [@.disabled]="reducedMotion()">
                @switch (activeView()) {
                    @case ('quote-page') {
                        <app-quote-view [expanded]="expanded()" [user]="user()" />
                    }
                    @case ('customer-page') {
                        <app-customer-view [expanded]="expanded()" [user]="user()" />
                    }
                    @case ('contact-page') {
                        <app-contact-view [expanded]="expanded()" [user]="user()" />
                    }
                    @case ('contract-page') {
                        <app-contract-view [expanded]="expanded()" [user]="user()" />
                    }
                    @default {
                        <app-home-view [expanded]="expanded()" [user]="user()" />
                    }
                }
            </div>
        }
    </nav>

    <!-- User profile / Settings trigger -->
    <div class="yllw-sidenav__profile-footer">
        <div class="yllw-sidenav__profile" (click)="onToggleSettingsDrawer()" [pTooltip]="profileTooltip()"
            [escape]="false" tooltipPosition="top">
            @if (user()?.profilePhotoUrl) {
            <p-avatar [image]="user()?.profilePhotoUrl" [size]="expanded() ? 'large' : 'normal'"
                shape="circle"></p-avatar>
            } @else {
            <p-avatar [label]="initials()" [size]="expanded() ? 'large' : 'normal'" shape="circle"></p-avatar>
            }
            @if (expanded()) {
            <div class="yllw-sidenav__profile-info">
                <span class="yllw-sidenav__profile-name">{{ user()?.name }}</span>
                <span class="yllw-sidenav__profile-company">
                    <img [src]="'https://flagcdn.com/48x36/' + user()?.selectedCompany?.countryCode?.toLowerCase() + '.png'"
                        alt="" class="flag-icon" />
                    {{ user()?.selectedCompany?.name?.toUpperCase() }}
                </span>
            </div>
            }
        </div>
        <app-notification-bell />
    </div>
</aside>
